import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { ILogoutModalProps } from "../interface";

import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { CheckBadgeIcon, InformationCircleIcon } from "@heroicons/react/24/outline";

export interface IInventoryOnboardModalState {
  titleContent: string;
  titlePrefix: string;
  status: boolean;
  positiveCallback: () => void;
  negativeCallback: () => void;
}

const InventoryOnboardingSuccessModal: React.FC<ILogoutModalProps> = () => {
  const { titleContent, status, titlePrefix, negativeCallback, positiveCallback } = useModalState(
    "INVENTORY_ONBOARD",
  ) as IInventoryOnboardModalState;
  return (
    <ModalPrompt
      modalId="INVENTORY_ONBOARD"
      showIcon
      titleIconContainerClassName={status ? "bg-green-100" : "bg-red-100"}
      titleIcon={
        status ? (
          <span>
            <CheckBadgeIcon className="w-6 h-6 text-green-800" />{" "}
          </span>
        ) : (
          <span>
            <InformationCircleIcon className="w-6 h-6 text-red-800" />{" "}
          </span>
        )
      }
      button={{
        primaryButtonText: status ? `Add ${titlePrefix}` : "Try Again",
        primaryButtonClassname:
          "rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600",
        secondaryButtonText: "View List",
        primaryCallback: () => {
          positiveCallback();
        },
        secondaryCallback: () => {
          negativeCallback();
        },
        shouldHideOnClick: true,
      }}
      title={`${titlePrefix} ${titleContent} Onboarded Successfully.`}
      content={
        <span className="text-xs">
          The vendor <strong>{titleContent}</strong> has been onboarded Successfully. You can check this in the list.
        </span>
      }
    />
  );
};

export default InventoryOnboardingSuccessModal;
